import { render, staticRenderFns } from "./ListaComponente.vue?vue&type=template&id=c6f111f0"
import script from "./ListaComponente.vue?vue&type=script&lang=js"
export * from "./ListaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports